import React, {PropsWithChildren} from 'react';

/**
 * Small, muted paragraph for secondary/explanatory text.
 *
 * Always renders a `<p>` with the base classes `text-sm gray-600`. Any
 * `className` supplied by the caller is appended so callers can adjust
 * alignment, spacing, etc. `className` is optional; when omitted only the
 * base classes are applied (with no trailing space).
 */
export default function LittleDetails({ children, className }: PropsWithChildren<{ className?: string }>) {
    const classes = className ? `text-sm gray-600 ${className}` : 'text-sm gray-600';
    return (
        <p className={classes}>
            {children}
        </p>
    );
}
